/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  SignatureMint721,
  SignatureMint721Interface,
} from "../SignatureMint721";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "string",
        name: "_contractURI",
        type: "string",
      },
      {
        internalType: "address payable",
        name: "_controlCenter",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nativeTokenWrapper",
        type: "address",
      },
      {
        internalType: "address",
        name: "_saleRecipient",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_royaltyBps",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "_feeBps",
        type: "uint128",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "signer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "mintedTo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenIdMinted",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "string",
            name: "uri",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "validityStartTimestamp",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "validityEndTimestamp",
            type: "uint128",
          },
          {
            internalType: "bytes32",
            name: "uid",
            type: "bytes32",
          },
        ],
        indexed: false,
        internalType: "struct ISignatureMint721.MintRequest",
        name: "mintRequest",
        type: "tuple",
      },
    ],
    name: "MintWithSignature",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "prevOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "NewOwner",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "NewSaleRecipient",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newFeeBps",
        type: "uint256",
      },
    ],
    name: "PrimarySalesFeeUpdates",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newRoyaltyBps",
        type: "uint256",
      },
    ],
    name: "RoyaltyUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "mintedTo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenIdMinted",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "uri",
        type: "string",
      },
    ],
    name: "TokenMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "restricted",
        type: "bool",
      },
    ],
    name: "TransfersRestricted",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TRANSFER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultSaleRecipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeBps",
    outputs: [
      {
        internalType: "uint120",
        name: "",
        type: "uint120",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "mintTo",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "string",
            name: "uri",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "validityStartTimestamp",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "validityEndTimestamp",
            type: "uint128",
          },
          {
            internalType: "bytes32",
            name: "uid",
            type: "bytes32",
          },
        ],
        internalType: "struct ISignatureMint721.MintRequest",
        name: "_req",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes",
      },
    ],
    name: "mintWithSignature",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenIdMinted",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nativeTokenWrapper",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextTokenIdToMint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "royaltyBps",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_saleRecipient",
        type: "address",
      },
    ],
    name: "setDefaultSaleRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_feeBps",
        type: "uint256",
      },
    ],
    name: "setFeeBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_restrictedTransfer",
        type: "bool",
      },
    ],
    name: "setRestrictedTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_royaltyBps",
        type: "uint256",
      },
    ],
    name: "setRoyaltyBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "transfersRestricted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "string",
            name: "uri",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "validityStartTimestamp",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "validityEndTimestamp",
            type: "uint128",
          },
          {
            internalType: "bytes32",
            name: "uid",
            type: "bytes32",
          },
        ],
        internalType: "struct ISignatureMint721.MintRequest",
        name: "_req",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes",
      },
    ],
    name: "verify",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type SignatureMint721ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SignatureMint721ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SignatureMint721__factory extends ContractFactory {
  constructor(...args: SignatureMint721ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _name: string,
    _symbol: string,
    _contractURI: string,
    _controlCenter: string,
    _trustedForwarder: string,
    _nativeTokenWrapper: string,
    _saleRecipient: string,
    _royaltyBps: BigNumberish,
    _feeBps: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SignatureMint721> {
    return super.deploy(
      _name,
      _symbol,
      _contractURI,
      _controlCenter,
      _trustedForwarder,
      _nativeTokenWrapper,
      _saleRecipient,
      _royaltyBps,
      _feeBps,
      overrides || {}
    ) as Promise<SignatureMint721>;
  }
  getDeployTransaction(
    _name: string,
    _symbol: string,
    _contractURI: string,
    _controlCenter: string,
    _trustedForwarder: string,
    _nativeTokenWrapper: string,
    _saleRecipient: string,
    _royaltyBps: BigNumberish,
    _feeBps: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _name,
      _symbol,
      _contractURI,
      _controlCenter,
      _trustedForwarder,
      _nativeTokenWrapper,
      _saleRecipient,
      _royaltyBps,
      _feeBps,
      overrides || {}
    );
  }
  attach(address: string): SignatureMint721 {
    return super.attach(address) as SignatureMint721;
  }
  connect(signer: Signer): SignatureMint721__factory {
    return super.connect(signer) as SignatureMint721__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SignatureMint721Interface {
    return new utils.Interface(_abi) as SignatureMint721Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SignatureMint721 {
    return new Contract(address, _abi, signerOrProvider) as SignatureMint721;
  }
}
